import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { clsx } from 'clsx';
import React from 'react';
import { spacing } from '../../styles/spacing.css';
import { getPixelValue } from '../../utils/units';
import { Flex } from '../Flex/Flex';
import { Icon } from '../Icon/Icon';
import { Layout } from '../Layout/Layout';
import * as styles from './Menu.css';

type MenuTriggerProps = DropdownMenu.DropdownMenuTriggerProps & {
  readonly side?: DropdownMenu.DropdownMenuContentProps['side'];
  readonly hideChevron?: boolean;
};

export const MenuTrigger: React.FC<MenuTriggerProps> = ({
  children,
  className,
  side = 'bottom',
  hideChevron = false,
  ...props
}) => (
  <Flex
    as={DropdownMenu.Trigger}
    className={clsx(styles.trigger, className)}
    {...props}
    cursor="pointer"
    gap={spacing.s04}
  >
    {children}
    {!hideChevron && (
      <Flex className={styles.icon}>
        <Icon className={styles.triggerIcon({ side })} name="dropdown" size="sm" variant="primary" />
      </Flex>
    )}
  </Flex>
);

export const MenuContent: React.FC<DropdownMenu.DropdownMenuContentProps> = ({ children, className, ...props }) => (
  <Layout
    as={DropdownMenu.Content}
    className={clsx(className, styles.content)}
    sideOffset={getPixelValue(spacing.s04)}
    width="165px"
    {...props}
  >
    {children}
  </Layout>
);

type MenuItemProps = DropdownMenu.DropdownMenuItemProps;

export const MenuItem: React.FC<MenuItemProps> = ({ children, className, ...props }) => {
  return (
    <Flex
      alignItems="center"
      as={DropdownMenu.Item}
      className={clsx(styles.item, className)}
      cursor="pointer"
      paddingBlock={spacing.s12}
      paddingInlineEnd={spacing.s20}
      paddingInlineStart={spacing.s16}
      {...props}
    >
      {children}
    </Flex>
  );
};

type MenuProps = DropdownMenu.DropdownMenuProps;

export const Menu: React.FC<MenuProps> = ({ children, ...props }) => (
  <DropdownMenu.Root {...props}>{children}</DropdownMenu.Root>
);
